import { Link } from 'react-router-dom'
import { useMeta } from '@/api/queries'
import { SelectField } from '@/components/ui/Field'

const linkClasses = 'font-medium text-accent-text hover:underline'

/** Picks a department from the admin-managed list (Admin → Departments); empty means none. */
export function DepartmentField({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const meta = useMeta()
  const options = meta.department_options
  const isAdmin = Boolean(meta.user?.is_admin)
  // Keep showing a value the list no longer has, so opening a form doesn't silently change it.
  const names = value && !options.includes(value) ? [...options, value] : options

  return (
    <SelectField
      label="Department"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={names.length === 0}
      hint={
        options.length === 0 ? (
          isAdmin ? (
            <>
              No departments yet.{' '}
              <Link to="/admin/departments" className={linkClasses}>
                Add them in Admin → Departments
              </Link>
              .
            </>
          ) : (
            'No departments have been set up yet.'
          )
        ) : (
          <>
            Optional. Lets people narrow questions to a department.
            {isAdmin && (
              <>
                {' '}
                <Link to="/admin/departments" className={linkClasses}>
                  Manage departments
                </Link>
              </>
            )}
          </>
        )
      }
    >
      <option value="">No department</option>
      {names.map((name) => (
        <option key={name} value={name}>
          {name}
        </option>
      ))}
    </SelectField>
  )
}
